<template>
  <div class="content has-text-centered">
    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <div v-if="tokenValid === 2">
            <h1>This link is expired</h1>
          </div>
          <div v-else-if="tokenValid === 1">
            <figure class="image" style="display: inline-block;">
              <img src="~assets/images/vti.png" alt="Image1" style="height: 100px; width: auto;"/>
            </figure>
            <div class="columns is-vcentered">
              <div class="column is-4 is-offset-4">
                <div class="box">
                  <div v-show="error" style="color:red; word-wrap:break-word;">
                    {{ error }}
                  </div>
                  <form v-on:submit.prevent="onSubmit" novalidate>
                    <label class="label has-text-left">New Password</label>
                    <p class="control">
                      <input v-model="password"
                            class="input"
                            type="password"
                            placeholder="Password"
                            v-validate="'required'"
                            name="password">
                      <span v-show="errors.has('password')" class="help is-danger">{{ errors.first('password') }}</span>
                    </p>
                    <label class="label has-text-left">Re-enter New Password</label>
                    <p class="control">
                      <input v-model="confirmPassword"
                            class="input"
                            type="password"
                            placeholder="Confirmation password"
                            v-validate="'required'"
                            name="confirm">
                      <span v-show="errors.has('confirm')" class="help is-danger">{{ errors.first('confirm') }}</span>
                    </p>
                    <hr>
                    <p class="has-text-centered">
                      <button type="submit"
                              class="button is-primary" :disabled="disableButton">Change Password</button>
                    </p>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </article>
        <alertModal :visible="showModal" :title="'Message'" :message="message" :okText="'OK'" :ok="closeModalBasic" @close="closeModalBasic"></alertModal>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import AuthenticationService from './../../services/authenticationservice'
import alertModal from '../../views/components/modals/AlertModal'
import LoadModal from '../../views/components/modals/LoadModal.vue'
import VeeValidate from 'vee-validate'
import Global from '../../services/globalservice'

Vue.use(VeeValidate, Global.VALIDATE_CONFIG)

export default {
  data () {
    return {
      password: '',
      confirmPassword: '',
      token: this.$route.params.token,
      error: '',
      tokenValid: 0,
      disableButton: false,
      showModal: false,
      message: null
    }
  },

  components: {
    alertModal
  },

  methods: {
    onSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.password === this.confirmPassword) {
            var data = {
              password: this.password,
              token: this.token
            }
            var self = this
            this.disableButton = true
            self.showLoad()
            AuthenticationService.resetForgotPassword(this, data, function (response) {
              self.hideLoad()
              self.error = response.status === 'fail' ? response.message : null
              if (response.status === 'success') {
                self.showModal = true
                self.message = 'Password changed successfully. Please login with the new password'
              }
              self.disableButton = false
            })
          } else {
            this.error = 'Password and Confirmation Password must match'
          }
        }
      })
    },

    closeModalBasic: function () {
      var self = this
      self.showModal = false
      setTimeout(function () {
        self.$router.push('/login')
      }, 500)
    },

    showLoad () {
      const LoadModalComponent = Vue.extend(LoadModal)
      var propsData = {
        visible: true
      }
      this.openLoadModal = new LoadModalComponent({
        el: document.createElement('div'),
        propsData
      })
    },

    hideLoad () {
      this.openLoadModal.deactive()
    }
  },

  created () {
    var self = this
    AuthenticationService.verifyForgotPasswordRequest(this, this.token, function (response) {
      self.tokenValid = response.status === 'success' ? 1 : 2
    })
  }
}
</script>

<style lang="scss" scoped>
.is-title {
  text-transform: capitalize;
}
</style>



// WEBPACK FOOTER //
// ResetPassword.vue?d276bd9c